import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
export default function StickyCTA() {
    const [show, setShow] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            if (dismissed) return;
            const y = window.scrollY;
            const contact = document.getElementById("contact");
            const nearContact = contact && contact.getBoundingClientRect().top < window.innerHeight * 1.2;
            setShow(y > 900 && !nearContact);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, [dismissed]);
    return (
        <AnimatePresence>
            {show && (
                <motion.div initial={{ y: 100, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 100, opacity: 0 }} transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }} data-testid="sticky-cta" className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-40 max-w-md mx-auto md:mx-0">
                    <div className="relative bg-[#152A20] backdrop-blur-xl border border-[#DFFF3D]/40 rounded-2xl p-4 pr-12 shadow-2xl warm-glow">
                        <button onClick={() => { setDismissed(true); setShow(false); }} data-testid="sticky-cta-close" aria-label="Dismiss" className="absolute top-3 right-3 w-7 h-7 rounded-full flex items-center justify-center text-[#A6BDB0] hover:text-white hover:bg-white/5 transition-colors">
                            <X className="w-4 h-4" />
                        </button>
                        <div className="flex items-center gap-3">
                            <div className="relative shrink-0">
                                <span className="absolute inset-0 rounded-full bg-[#DFFF3D] vu-live-dot" />
                                <span className="relative block w-2.5 h-2.5 rounded-full bg-[#DFFF3D]" />
                            </div>
                            <div className="mono text-[10px] text-[#DFFF3D]">BOOKING Q1 · 3 SLOTS LEFT</div>
                        </div>
                        <div className="mt-2 mb-3">
                            <div className="font-display text-white text-[15px] leading-tight">Get your free 30-min growth audit</div>
                            <div className="text-[12px] text-[#A6BDB0] mt-1">No pitch. Just where the fastest wins are hiding.</div>
                        </div>
                        <a href="#contact" data-testid="sticky-cta-btn" className="vu-btn vu-cta-pulse inline-flex items-center gap-2 w-full justify-center bg-[#DFFF3D] text-[#0E1F16] px-5 py-3 rounded-full font-semibold text-[13.5px] hover:bg-[#EAFF6B]">
                            Claim my free audit <i className="fa-solid fa-arrow-right text-xs" />
                        </a>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
